// This File contains all the Pattern Collections used in the filters.
// It contains filter pattern keys and values for different filters.

import { PatternCollectionType } from '../ChartFieldFilter/UserFilterCardInterface';

export const searchConditionOperatorText: string[] = [
  'beginsWith',
  'endsWith',
  'contains',
  'exactMatch',
];
// export const TopNOperators: string[] = ['ascending', 'descending'];
export const TopNOperators: PatternCollectionType[] = [
  { key: 'ascending', value: 'Ascending Wise Rank' },
  { key: 'descending', value: 'Descending Wise Rank' },
];
export const withPatternCollections: PatternCollectionType[] = [
  { key: 'beginsWith', value: 'Start With' },
  { key: 'endsWith', value: 'Ends With' },
  { key: 'contains', value: 'Contains' },
  { key: 'exactMatch', value: 'Exact Match' },
];

export const datePatternCollections: PatternCollectionType[] = [
  { key: 'year', value: 'Year' },
  { key: 'quarter', value: 'Quarter' },
  { key: 'month', value: 'Month' },
  { key: 'yearquarter', value: 'Year Quarter' },
  { key: 'yearmonth', value: 'Year Month' },
  { key: 'date', value: 'Date' },
  { key: 'dayofmonth', value: 'Day Of Month' },
  { key: 'dayofweek', value: 'Day Of Week' },
];

export const datePatternRelativeFilterCollections: PatternCollectionType[] = [
  { key: 'day', value: 'Days' },
  { key: 'weekSunSat', value: 'Weeks (Sun-Sat)' },
  { key: 'weekMonSun', value: 'Weeks (Mon-Sun)' },
  { key: 'month', value: 'Months' },
  { key: 'year', value: 'Years' },
  { key: 'rollingWeek', value: 'Rolling Weeks' },
  { key: 'rollingMonth', value: 'Rolling Months' },
  { key: 'rollingYear', value: 'Rolling Years' },
];

export const AnchorDatePatternRelativeFilterCollections: PatternCollectionType[] = [
  { key: 'today', value: 'Today' },
  { key: 'yesterday', value: 'Yesterday' },
  { key: 'tomorrow', value: 'Tommorow' },
  { key: 'columnMaxDate', value: 'Column Max Date' },
  { key: 'specificDate', value: 'Specific Date' },
];

export const datePatternSearchConditionCollections: PatternCollectionType[] = [
  { key: 'year', value: 'Year' },
  { key: 'quarter', value: 'Quarter' },
  { key: 'month', value: 'Month' },
  { key: 'date', value: 'Date' },
  { key: 'dayofmonth', value: 'Day Of Month' },
  { key: 'dayofweek', value: 'Day Of Week' },
];
export const equalPatternCollections = [
  { key: 'greaterThan', value: '>  Greater than' },
  { key: 'lessThan', value: '<  Less than' },
  { key: 'greaterThanOrEqualTo', value: '>= Greater than or Equal to' },
  { key: 'lessThanOrEqualTo', value: '<= Less than or Equal to' },
  { key: 'equalTo', value: '=  Equal to' },
  { key: 'notEqualTo', value: '<> Not Equal to' },
  { key: 'between', value: '>= Between <=' },
  { key: 'blank', value: '   (Blank)' },
];

export const RelativeFilterPatternCollections: PatternCollectionType[] = [
  { key: 'last', value: 'Last' },
  { key: 'current', value: 'Current' },
  { key: 'next', value: 'Next' },
];
